import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { clearRegistration } from '../../actions/registration'

class HomeStepShare extends Component {

  componentDidMount() {
   if (!this.props.startOk) {
     this.props.history.push('/')
   }
  }

  onClickBackToHome() {
    this.props.clearRegistration()
    this.props.history.push('/')
  }

  onClickSharesAccept(){
    window.location.href = 'https://www.facebook.com/sharer/sharer.php?u=https://lembrareajudar.rpc.com.br/'
  }

  render() {
    return (
      <div>
        <div className="modal-header">
          <div className="container">
            <h4 className="modal-title" id="myModalLabel">Obrigado mais uma vez!</h4>
          </div>
        </div>
        <div className="agradecimento">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <img src="images/heart.png" alt="corazon" />
                <p>É muito bom poder contar com a sua ajuda.</p>
                <p>Sua inscrição foi confirmada e, a partir de <b>novembro</b>, uma ONG entrará em contato para agendar o seu voluntariado.</p>
                  <div className="compartilhar"><button onClick={this.onClickSharesAccept.bind(this)}>Compartilhe</button></div>
                  <div className="paginainicial">
                    <a onClick={this.onClickBackToHome.bind(this)}>
                      <button>Ir para página inicial</button>
                    </a>
                  </div>
			        </div>
            </div>
          </div>
        </div>
        <div className="assinatura">
          <img src="images/assinatura.png" alt="Assinatura"/>
        </div>
      </div>
    )
  }
}

HomeStepShare.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  clearRegistration: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeStepShare.defaultProps = {
  history: {
    push: () => { },
  },
}


const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  clearRegistration,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStepShare)



// WEBPACK FOOTER //
// ./src/components/home/Share.js